import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import s from './Checkbox.module.scss';
import Icon from '../Icon/Icon';

const Checkbox = ({
    label,
    checked = false,
    onChange,
    modifier,
    id,
    disabled = false,
}) => {
    const classes = classNames(
        s.Root,
        { [s['Root--Checked']]: checked },
        { [s[`Root--${modifier}`]]: modifier },
        { [s['Root--Disabled']]: disabled }
    );
    const whiteCheckmark = modifier === 'Alternative';

    const handleChange = (e) => {
        if (!disabled && onChange) {
            onChange(e);
        }
    };

    return (
        <label className={classes}>
            <input
                type="checkbox"
                checked={checked}
                onChange={handleChange}
                disabled={disabled}
                className={s.Input}
                value={id}
            />
            <span className={s.Checkmark}>
                <Icon
                    name={whiteCheckmark ? 'CheckSmallWhite' : 'CheckSmall'}
                    className={s.CheckIcon}
                />
            </span>
            <span className="sr-only">{label}</span>
        </label>
    );
};

Checkbox.propTypes = {
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    modifier: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
};

export default Checkbox;
